var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BzOb_Account"},[(_vm.theme == 'base')?_c('img',{attrs:{"src":require("../../assets/menu_base.svg")},on:{"click":_vm.menu_opening}}):_vm._e(),(_vm.theme == 'white')?_c('img',{attrs:{"src":require("../../assets/menu_white.svg")},on:{"click":_vm.menu_opening}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }